import { getImageData } from "gatsby-plugin-image"

function urlBuilder({ baseUrl, width, height, format, options }) {
  return `https://secure.sweetcombecottages.co.uk/${baseUrl}?w=${width}&fmt=${format}&q=${options.quality}`
}

export function getIproPropertyImageData({ image, ...props }) {
  return getImageData({
    baseUrl: image.url,
    sourceWidth: image.width,
    sourceHeight: image.height,
    urlBuilder,
    pluginName: 'gatsby-source-graphql',
    // If your host supports auto-format/content negotiation, pass this as the formats array
    formats: [`webp`, `avif`],
    ...props,
  })
}